import React, {Component} from 'react';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import Errors from '../common/Errors';
import {Link,Redirect} from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import * as Util from '../common/Util';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import RequiredAstrisk from '../common/RequiredAstrisk'

class ProcessPayment extends Component{
    constructor(props){
        super(props);
        this.state = {
            signatureRequestId: null,
            amount: 0,
            amountError: '',
            messageforList: '',
            notes: '',
            redirectPage: false,
            redirectToErrorPage: false,
            redirectToNotFoundPage: false,
            redirectToForbiddenPage: false,
            effectiveDate: null,
            formatEffectiveDate: null,
            autoPayreference: "creditcard",
            encodedPaymentMethods: [],
            disabledButton: false,
            recipient: null,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            jsonObj: {},
            showModal: false,
        }
        this.fetchDetailToProcessPayment = this.fetchDetailToProcessPayment.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
        this.handleProcessPayment = this.handleProcessPayment.bind(this)
        this.validator = new SimpleReactValidator ({
            autoForceUpdate: this,
            element: false
        });
    }
    handleChangeDatePicker(name, formattedName, date) {
        this.setState({
            [name]: date
        });
        if(date){
            this.setState({[formattedName]: moment(date).format("YYYY-MM-DD")})
        }else{
            this.setState({[formattedName]: date})
        }
    }
    componentDidMount(){
        if(this.props.params && this.props.params.signatureRequestId){
            this.fetchDetailToProcessPayment();
        }
    }

    fetchDetailToProcessPayment() {
        this.setState({showLoader: true});
        fetch(this.props.api + '/payment/signature-request/' + this.props.params.signatureRequestId , {
            method: 'GET',
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        }).then(response => response.json())
            .then(json => {
                if (json && json.isError === false) {
                    this.setState({signatureRequestId: this.props.params.signatureRequestId,
                        encodedPaymentMethods:json.encodedPaymentMethods,
                        amount: json.amount, recipient: json.recipient});
                    if(json.encodedPaymentMethods && json.encodedPaymentMethods.length === 1){
                        this.setState({autoPayreference: json.encodedPaymentMethods[0].paymentMethodType})
                    }
                } else {
                    if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.message === "Signature Request not found" && json.isError === true) {
                        this.setState({showLoader: false, redirectToNotFoundPage: true});
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({showLoader: false, redirectToForbiddenPage: true});
                    }
                }
                this.setState({showLoader: false});
            }).catch(error => {
            console.log(error);
            this.setState({showLoader: false});

        });

    }

    handleChange(event){
        const { name, value } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleProcessPayment(event){
        event.preventDefault()
        let _this = this
        _this.setState({amountError:""})
        if (_this.validator.allValid()) {
            if(_this.state.amount > 0){
                const jsonObj = {
                    signatureRequestId:this.props.params.signatureRequestId,
                    notes:this.state.notes,
                    effectiveDate:this.state.formatEffectiveDate,
                    autoPayreference: this.state.autoPayreference === 'creditcard' ? 1 : (this.state.autoPayreference === 'ach' ? 2 : null),
                    amount:this.state.amount
                };
                _this.setState({jsonObj:jsonObj})
                _this.setState({showModal:true})
            }else{
                _this.setState({showModal:false})
                _this.setState({amountError:"Please enter valid amount"})
            }
        }else {
            _this.validator.showMessages();
            _this.forceUpdate();
            _this.setState({showModal:false})
        }
    }


    handleSubmit(event) {
        event.preventDefault();
        console.log(this.validator.allValid());
        const {apiStatus} = this.state;
        let _this = this
        _this.setState({showLoader: true});
        _this.handleClosePopUP(event)
        fetch(_this.props.api + "/payment", {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(_this.state.jsonObj),
            headers: {
                'X-AUTH-TOKEN': _this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json && json.isError === false) {
                    Util.successResponse(apiStatus, json);
                    _this.setState({messageforList: "Successfully Processed payment", redirectPage: true})
                } else {
                    Util.errorResponse(apiStatus, json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    }
                }
                _this.setState({
                    disabledButton: false,
                    apiStatus: apiStatus,
                    showLoader: false
                });
            })
            .catch(error => {
                Util.errorCatchResponse(apiStatus, error);
                _this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
            });
    }

    handleClosePopUP(event){
        this.setState({showModal:false})
    }

    render() {
        let _this = this;
        let htmlPaymentMethods = [];
        if (_this.state.encodedPaymentMethods && _this.state.encodedPaymentMethods.length > 0) {
            if (_this.state.encodedPaymentMethods.length > 1) {
                _this.state.encodedPaymentMethods.map(function (encodedPM, index) {
                    if (encodedPM.paymentMethodType === "creditcard") {
                        htmlPaymentMethods.push(
                            <label style={{position:'relative', display:'block'}}> <input type="radio" value="creditcard" name="autoPayreference"
                                           onChange={_this.handleChange}/><i></i> {encodedPM.encodedValue} </label>
                        )
                    } else {
                        htmlPaymentMethods.push(
                            <label> <input type="radio" value="ach" name="autoPayreference" onChange={_this.handleChange}/><i></i> {encodedPM.encodedValue}
                            </label>
                        )
                    }
                    return null
                })
            } else {
                console.log("Here")
                htmlPaymentMethods.push(<span
                    key={Math.random()}>{_this.state.encodedPaymentMethods[0].encodedValue}</span>)
            }
        }
        let styles = _this.state.showModal
            ? { display: "block" }
            : { display: "none" };
        return (

            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToNotFoundPage={this.state.redirectToNotFoundPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {(this.state.redirectPage && this.state.redirectPage === true && this.state.messageforList) ? (
                    <Redirect to={'/payment/list/success/' + this.state.messageforList}/>) : null}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('payment.processPaymentheader')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{minHeight:'490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <form className="form-horizontal" onSubmit={this.handleProcessPayment}>
                                    <div className="col-md-12">
                                        <div className="col-md-8">
                                            <div className="form-group row">
                                                <label className="col-lg-6 control-label">Amount:<RequiredAstrisk/></label>
                                                <div className="col-lg-6">
                                                    <input type="number" className="form-control" id="amount"
                                                           onChange={this.handleChange}
                                                           name="amount"
                                                           value={parseFloat(this.state.amount.toString().replace(/,/g,''))}
                                                    />
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('amount', this.state.amount, 'required|numeric|min:0.01,num')}
                                                        <span>{this.state.amountError}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-6 control-label">Payment Method:<RequiredAstrisk/></label>

                                                <div className="col-lg-6">
                                                    {htmlPaymentMethods}
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-6 control-label">Effective Date:<RequiredAstrisk/></label>
                                                <div className="col-lg-6">
                                                       <DatePicker className="form-control" autoComplete="off"
                                                                name="effectiveDate" id="effectiveDate"
                                                                selected={this.state.effectiveDate}
                                                                onChange={this.handleChangeDatePicker.bind(this,'effectiveDate', 'formatEffectiveDate')}
                                                    />
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('effectiveDate', this.state.effectiveDate, 'required')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-6 control-label">Notes:</label>
                                                <div className="col-lg-6">
                                                    <input type="text" className="form-control" id="notes"
                                                           onChange={this.handleChange}
                                                           name="notes"
                                                           value={this.state.notes}/>
                                                    <div style={{color:"red"}}>
                                                        {this.validator.message('notes', this.state.notes, 'min:3|max:300')}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-lg-6 control-label">&nbsp;</label>
                                                <div className="col-lg-6">
                                                    <Link to="/" className="btn btn-white" style = {{marginLeft: '7px'}}>{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                                    <button className="btn btn-primary" type="submit"  data-toggle="modal" data-target="#processPaymentModal" disabled={this.state.disabledButton===true}>{_this.props.msg('form.label.submit1')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                {_this.state.showModal === true?
                    <div className="backdrop">
                    <div className="modal inmodal" id="processPaymentModal" tabIndex="-1" role="dialog"
                         aria-hidden="true" style={styles}>
                        <div className="modal-dialog" style={{marginTop:'65px'}}>
                            <div className="modal-content animated flipInY">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" onClick={(e)=>_this.handleClosePopUP(_this)}><span
                                        aria-hidden="true">&times;</span><span className="sr-only">Close</span></button>
                                    <h4 className="modal-title">Payment Confirmation</h4>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        A payment for $ {_this.state.amount} will be
                                        processed now. Please click the "Continue" button to confirm.

                                        If you elect to click "Cancel", then the payment will not be processed and the
                                        document will not be signed/submitted.
                                    </p>
                                </div>
                               {/* <p style={{height:'40px'}}>Please confirm payment of
                                    $ {_this.state.amount} towards {_this.state.recipient && _this.state.recipient.name} ({_this.state.recipient && _this.state.recipient.email})
                                    '{_this.state.autoPayreference}' payment method.</p>*/}
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-white"
                                            data-dismiss="modal" onClick={(e)=>_this.handleClosePopUP(_this)}>{_this.props.msg('form.label.cancelButton')}</button>
                                    <button type="Submit" className="btn btn-primary" data-dismiss="modal"
                                            disabled={this.state.disabledButton === true}
                                            onClick={_this.handleSubmit}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>:null
                }
            </div>
        )
    }
}
export default ProcessPayment


// WEBPACK FOOTER //
// ./src/components/payment/ProcessPayment.js